<template>
  <div id="gmf-toasts" class="gmf-context">
    <div class="gmf-toast-anchor" ref="anchor" :style="toastAnchorStyle">
      <div v-for="evt in toasts" :key="evt.id" :style="{opacity: fadingToasts[evt.id] ? 0 : 1}">
        <EventRow :evt="evt" :key="evt.id"></EventRow> 
      </div>
    </div>
  </div>
</template>

<style>
#gmf-toasts {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: calc(var(--gmf-modal-z-index) + 1);
}
#gmf-toasts .gmf-notif-event-row {
  background: white;
  margin-top: var(--gmf-object-spacing);
  box-shadow: 0px 2px 6px rgb(0 0 0 / 20%);
  padding: var(--gmf-p-4);
  border-radius: var(--gmf-rounding);
  transition: opacity 0.4s ease-out;
}
.gmf-toast-anchor {
  top: 0;
  position: absolute;
  right: 0;
  width: 420px;
  max-width: calc(100vw - 32px);
  will-change: transform;
}
</style>

<script>
import timeAgo from '@/utils/timeAgo';
import notificationFetcher from './notificationFetcher';
import getNotificationText from './getNotificationText';
import md from '@/utils/md';
import EventRow from './EventRow.vue';

export default {
  name: 'Notifications/Toasts',
  components: {
    EventRow,
  },
  data () {
    return {
      toasts: [],
      yOffset: 0,
      animatedOffset: true,
      toastTime: 5,
      fadingToasts: {},

      busyUntil: 0,
    };
  },
  mounted () {
    notificationFetcher.addEventListener('newToasts', this.onNewToasts);
  },
  unmounted () {
    notificationFetcher.removeEventListener('newToasts', this.onNewToasts);
  },
  computed: {
    toastAnchorStyle () {
      return {
        'transform': 'translateY(-' + this.yOffset + 'px)',
        'transition': this.animatedOffset ? 'transform 0.3s ease-in-out' : null,
      };
    },
  },
  methods: {
    getText (evt) {
      const body = getNotificationText(evt) || evt.body;
      return md(body);
    },
    onNewToasts(evts) {
      this.toasts.push(...evts);
      for (const { id } of evts) {
        this.fadingToasts[id] = true;
      }
      this.animatedOffset = true;
      this.$nextTick(()=>{
        for (const { id } of evts) {
          this.fadingToasts[id] = false;
        }
        this.reposition();
      });

      this.busyUntil = Date.now() + 800;

      setTimeout(() => {
        this.removeToasts(evts);
      }, this.toastTime * 1000);
    },
    cleanupToasts (evts) {
      if (Date.now() < this.busyUntil) {
        // console.log('Rescheduling cleanup because we are busy animating');
        setTimeout(() => {
          this.cleanupToasts(evts);
        }, 450);
        return;
      }
      this.animatedOffset = false;
      this.$nextTick(()=>{
        for (const evt of evts) {
          const index = this.toasts.indexOf(evt);
          if (index >= 0) {
            this.toasts.splice(index, 1);
          }
        }
        this.$nextTick(()=>{
          this.reposition();
        });
      });
    },
    removeToasts (evts) {
      for (const { id } of evts) {
        this.fadingToasts[id] = true;
      }
      setTimeout(() => {
        this.cleanupToasts(evts);
      }, 500);
    },
    reposition () {
      this.yOffset = this.$refs.anchor.getBoundingClientRect().height;
    },
    timeAgo,
  },
};
</script>
